import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ed1a398"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "hover_tool_tip"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }

import { computed, withDefaults, ref } from 'vue'
import { getEquipmentType } from '@/js/utils/util'

type PropsType = {
  position?: string
  width?: number
  toolTipText?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HoverToolTip',
  props: {
    position: { default: 'top' },
    width: { default: 100 },
    toolTipText: null
  },
  setup(__props: any) {

const props = __props as { position: string, width: number, toolTipText?: string };



const isToolTipShow = ref(false)
const position = props.position ? ref(props.position) : ref('top')
const toolTipBox = ref()

const toolTipStyle = computed(() => ({
  width: props.width + 'px',
}))

const useToolTip = computed(() => getEquipmentType() === 'pc' && props.toolTipText)

const hideToolTip = () => {
  isToolTipShow.value = false
}
const showToolTip = () => {
  const clientRect = toolTipBox.value.getBoundingClientRect()
  const positions = []
  const bodyWidth = document.body.clientWidth
  const bodyHeight = document.body.clientHeight
  // leftとrightとかbottomとtopが一緒に空間が足りない時はその位置に出ます。
  if (props.position === 'top' || props.position === 'bottom') {
    // 上に空間がない場合 65はtool_tipのheight
    if (clientRect.top < 65) {
      positions.push('bottom')
    }
    // 下に空間がない場合 85はtool_tipのheightやtoolTipBoxのheight
    if (clientRect.bottom >= bodyHeight - 85) {
      positions.push('top')
    }
    // 右に空間がない場合 17はpadding(16)+空間のための1
    if (clientRect.left + props.width / 2 + 17 > bodyWidth) {
      if (positions.length > 0) {
        positions.push('left')
      } else {
        positions.push(props.position + '_left')
      }
    }
    // 左に空間がない場合 17はpadding(16)+空間のための1
    if (clientRect.left < props.width / 2 + 17) {
      if (positions.length > 0) {
        positions.push('right')
      } else {
        positions.push(props.position + '_right')
      }
    }
  } else {
    // 右に空間がない場合 20は三角形の長さ 20は三角形の大きさ
    if (clientRect.left + props.width + 20 > bodyWidth) {
      positions.push('left')
    }
    // 左に空間がない場合 20は三角形の大きさ
    if (clientRect.left < props.width + 20) {
      positions.push('right')
    }
    // 上に空間がない場合 17はtool_tipのpadding(16)+空間のための1
    if (clientRect.top < 17) {
      positions.push('bottom')
    }
    // 下に空間がない場合 17はtool_tipのpadding(16)+空間のための1
    if (clientRect.bottom >= bodyHeight - 17) {
      positions.push('top')
    }
  }
  if (positions.length === 0) {
    position.value = props.position
  } else {
    position.value = positions.join('_')
  }
  isToolTipShow.value = true
}

return (_ctx: any,_cache: any) => {
  return (_unref(useToolTip))
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("span", {
              class: _normalizeClass(["tool_tip", _unref(position)]),
              style: _normalizeStyle(_unref(toolTipStyle)),
              innerHTML: __props.toolTipText
            }, null, 14, _hoisted_2), [
              [_vShow, isToolTipShow.value]
            ])
          ]),
          _: 1
        }),
        _createElementVNode("span", {
          ref_key: "toolTipBox",
          ref: toolTipBox,
          onMouseleave: hideToolTip,
          onMouseenter: showToolTip
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 544)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}
}

})